// Reviews slider + G2 / TrustRadius tabs, same behaviour as infuse.com and demand-engine.
// Markup comes from infuse.com (includes/api-fetch/get-reviews.php), so selectors must match it.
import Swiper from 'swiper/bundle';

const config = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 0,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: '.swiper-btn__next',
    prevEl: '.swiper-btn__prev',
  },
  breakpoints: {
    // 1 per view up to 1025px, matching the until(1025px) breakpoint in the styles
    1026: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 24,
    },
  },
};

export default function reviews() {
  const sliderEl = document.querySelector('.our-reviews__items');
  if (!sliderEl) return;

  let slider = new Swiper(sliderEl, config);

  const tabItems = document.querySelectorAll('.our-reviews__tabs-item');
  const wrapper = sliderEl.querySelector('.swiper-wrapper');
  const slides = [...sliderEl.querySelectorAll('.our-review__item')];

  // Swiper can't filter slides, so rebuild it with the matching ones
  tabItems.forEach((tab) => {
    tab.addEventListener('click', () => {
      const { cat } = tab.dataset;

      tabItems.forEach((item) => item.classList.toggle('active', item === tab));

      slider.destroy(true, true);
      wrapper.innerHTML = '';
      slides
        .filter((slide) => cat === 'all' || slide.dataset.cat === cat)
        .forEach((slide) => wrapper.appendChild(slide));

      slider = new Swiper(sliderEl, config);
    });
  });
}
